// test759
(759 && 0);
